import {AvstemningMedResultatModell, AvstemningsalternativMedResultatModell, AvstemningsstatusModell} from "../tjenester/ressurser/generertNg2HttpKlient";
import {erIkkeTomStreng, sammenliknAlfanumerisk} from "felles-ng2/støttefunksjoner/strenger";
import {i18n, Oversettelser} from "../tjenester/i18n/Oversettelser";
import {erIkkeNil} from "../støttefunksjoner/nilsjekk";


export function sorterAvstemning(a: AvstemningMedResultatModell, b: AvstemningMedResultatModell): number {
    if (a === b) return 0;

    const sortering = sammenliknAlfanumerisk(a.tittel, b.tittel);
    if (sortering != 0) return sortering;

    return a.id.localeCompare(b.id);
}

export function beslutningBeskrivelseMedAvstemningSomMal(avstemning: AvstemningMedResultatModell, avstemningsstatus: AvstemningsstatusModell, oversettelser:Oversettelser):string {
    const overskrift = oversettelser.oversett(i18n('Avstemningsresultat'));
    const vinnere = avstemning.avstemningsalternativer.filter(alternativ => alternativ.erVinner);
    const resultat = avstemning.avstemningsalternativer.map(alternativ=> {
        const tekst = antallStemmer(alternativ) == 1 ?
          oversettelser.oversett(i18n('{tittel} ({antall} stemme)'), {tittel: alternativ.tittel, antall: antallStemmer(alternativ)}) :
          oversettelser.oversett(i18n('{tittel} ({antall} stemmer)'), {tittel: alternativ.tittel, antall: antallStemmer(alternativ)}) ;
        return alternativ.erVinner ? `<li><b>${tekst}</b></li>` : `<li>${tekst}</li>`;
    }).join('');
    let vinnertekst = '';
    if (vinnere.length === 1) {
        vinnertekst = antallStemmer(vinnere[0]) == 1 ?
          oversettelser.oversett(i18n('Alternativ "{tittel}" vant med {antall} stemme.'), {tittel: vinnere[0].tittel, antall: antallStemmer(vinnere[0])}):
          oversettelser.oversett(i18n('Alternativ "{tittel}" vant med {antall} stemmer.'), {tittel: vinnere[0].tittel, antall: antallStemmer(vinnere[0])});
    }
    if (vinnere.length > 1) {
        const titler = vinnere.reduce((titler: string, alternativ: AvstemningsalternativMedResultatModell, indeks: number) => {
            const skilletegn = indeks == 0 ? '' : indeks == vinnere.length - 1 ? (' ' + oversettelser.oversett(i18n('og')) + ' ') : ', ';
            return `${titler}${skilletegn}"${alternativ.tittel}"`;
        }, '');
        vinnertekst = antallStemmer(vinnere[0]) ==1?
          oversettelser.oversett(i18n('Alternativene {titler} vant med {antall} stemme.'), {titler: titler, antall: antallStemmer(vinnere[0])}):
          oversettelser.oversett(i18n('Alternativene {titler} vant med {antall} stemmer.'), {titler: titler, antall: antallStemmer(vinnere[0])});
    }
    let beskrivelse = erIkkeNil(avstemning.beskrivelse) ? `${avstemning.beskrivelse}<br><br>` : '';
    beskrivelse += `<i>${overskrift}:</i><ul>${resultat}</ul>`;
    if (erIkkeTomStreng(vinnertekst)) beskrivelse += `<br>${vinnertekst}`;
    beskrivelse += '<br>' + oversettelser.oversett(i18n('{antallStemt} av {antallStemmeberettigede} stemmeberettigede har avgitt stemme.'), {antallStemt: avstemningsstatus.antallStemmerAvgittPerAvstemning[avstemning.id], antallStemmeberettigede: avstemningsstatus.antallStemmeberettigedeDeltakere});
    return beskrivelse;
}

function antallStemmer(alternativ: AvstemningsalternativMedResultatModell) {
    return alternativ.antallStemmer ?? 0;
}
